import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { colors } from '../WindowConfig';

interface TutorialAreaProps {}

const Container = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: ${colors.primary};
  flex-direction: column;
`;

const TutorialArea: React.FC<TutorialAreaProps> = () => {
  const s80 = useSelector((state: any) => state.executor.s80);
  const { tutorialArea } = s80;
  if (tutorialArea.show) {
    return (
      <Container data-area="tutorial-area">
        <div>{tutorialArea.term}</div>
      </Container>
    );
  }
  return <></>;
};

export default TutorialArea;
